import "./WindowsNotification.scss";
import {CloseIcon, Flex, Input, Text} from "@fluentui/react-northstar";
import React, { useEffect } from "react";
import languageObject from "../../translations";
import translations from "../../translations";
import {ITranslationMessage} from "../../Interfaces/TranslationMessage";
import CCPLogo from "assets/ccp_logo.png";

type Props = {
    data: ITranslationMessage,
    botName?: string | undefined,
}

export const WindowsNotification = (props: Props) => {
    const {image, banner, buttons, askFeedback} = props.data;

    const showButtonsPart = buttons.length > 0 || askFeedback;
    
    const title = !props.data.title ? translations.translate("Title") : props.data.title;

    const author = !props.data.author ? translations.translate("Author") : props.data.author;

    const message = !props.data.message ? translations.translate("Description") : props.data.message;

    const lines = message?.split("\n\n");

    return (
        <div className="windows-notification no-select">
            <Flex vAlign={"center"} className="windows-notification-header">
                <img alt={"Company Communicator Pro logo"} src={CCPLogo}/>
                <Flex fill className={"overflow-hidden"}>
                    <Text truncated size={"small"} content={props.botName ?? "Company Communicator Pro"}/>
                </Flex>
                <CloseIcon size={"small"} className={"windows-notification-close-btn"} outline/>
            </Flex>
            <Flex column className={"windows-notification-body"}>
                <Flex vAlign={"center"} gap={"gap.medium"}>
                    <img alt={"Windows notification logo"} src={CCPLogo} className={"windows-notification-logo"}/>
                    <Flex column>
                        <Text className={"overflow-wrap"} weight={"semibold"} content={title}/>
                        <Text className={"windows-notification-light-text"} content={author}/>
                    </Flex>
                </Flex>
                {banner &&
                    <img
                        alt={"Notification banner"}
                        src={banner.content}
                        className={"windows-notification-banner"}
                    />
                }
                <Flex column styles={{marginTop: "15px"}}>
                    {lines?.map((l, i) =>
                        (
                            l === "" ?
                                <br key={i}/>
                                :
                                <Text key={"line" + i} content={l}/>
                            )
                    )}
                </Flex>
                {image &&
                    <img
                        alt={"Notification image"}
                        src={image.content}
                        className={"windows-notification-image"}
                    />
                }
                {askFeedback &&
                    <Input
                        fluid
                        className={"windows-notification-input"}
                        placeholder={languageObject.translate("TypeAReply")}
                    />
                }
                {showButtonsPart &&
                    <div className={"windows-notification-buttons-grid"}>
                        {askFeedback &&
                            <div key={"ask-feedback-btn"} className={"windows-notification-buttons-grid-item"}>
                                {languageObject.translate("Reply")}
                            </div>
                        }
                        {buttons.slice(0, 5).map(b => !b.title ? null : (
                            <div key={b.id} className={"windows-notification-buttons-grid-item"}>
                                <Text content={b.title}/>
                            </div>
                        ))}
                    </div>
                }
            </Flex>
        </div>
    )
}